import { render } from "./MyFavourites.vue?vue&type=template&id=77e68a47"
import script from "./MyFavourites.vue?vue&type=script&lang=js"
export * from "./MyFavourites.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__